import React from "react";

const Waveform = ({ isAnimating = true, barCount = 40 }) => {
  return (
    <div className="flex items-center justify-center gap-[2px] h-16">
      {Array.from({ length: barCount }).map((_, i) => (
        <div
          key={i}
          className={`w-1 bg-gradient-to-t from-primary to-secondary rounded-full ${
            isAnimating ? "waveform-bar" : ""
          }`}
          style={{
            height: isAnimating ? undefined : `${Math.random() * 60 + 20}%`,
            animationDelay: isAnimating ? `${i * 0.05}s` : undefined,
            minHeight: "10%",
          }}
        />
      ))}
    </div>
  );
};

export default Waveform;
